import { useEffect, useState } from "react";
import Service from "src/setup/network";

export const setDashLayoutHeading = (
  dashLayoutHeading: string | undefined
) => ({
  type: 'SET_DASH_LAYOUT_HEADING',
  payload: dashLayoutHeading,
});

export const getSubscriptionModels = async () => {
  const { data } = await Service.get(`/subscriptions/visible`);
  return data;
};

export const useSubscriptionModels = () => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);

    getSubscriptionModels()
      .then((res) => setData(res))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
};

interface SubscriptionResponseModel {
  subscriptionInfo: any[];
  pricingInfo: any[];
  usageInfo: any[];
  paymentInfo: any[];
}

export const getBusinessSubscriptionModel = (businessId: string) => {
  const [data, setData] = useState<SubscriptionResponseModel | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const fetchData = async () => {
    const { data } = await Service.get(`/business-subscriptions/${businessId}/subscription/flexible`);
    return data;
  };

  useEffect(() => {
    setLoading(true);

    fetchData()
      .then((res) => setData(res))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
};